var currentSchoolYear = 2016;
var nextSchoolYear = 2017;
var WMSMapLayer = {
  AERIAL_VIEW: {
    id: 'AERIAL_VIEW',
    label: 'Aerial View',
    srs: 'EPSG:32755',
    layers: 'act:hires_aerial_nm',
    format: 'image/jpeg',
    tiled: true,
    opacity: 1
  },
  LAND_DETAILS: {
    id: 'LAND_DETAILS',
    label: 'Land Details',
    srs: 'EPSG:32755',
    layers: 'act:base',
    format: 'image/gif',
    tiled: true,
    opacity: 1
  },
  HYBRID_OVERLAY: {
    id: 'HYBRID_OVERLAY',
    label: 'Hybrid Overlay',
    srs: 'EPSG:32755',
    layers: 'act:hybrid_overlay',
    format: 'image/gif',
    tiled: true,
    opacity: 0.6
  },
  TP_ZONES: {
    id: 'TP_ZONES',
    label: 'Territory planning zones',
    srs: 'EPSG:32755',
    layers: 'act:tp_zones',
    format: 'image/gif',
    tiled: true,
    opacity: 0.4
  },
  EASEMENTS: {
    id: 'EASEMENTS',
    label: 'Easement information',
    srs: 'EPSG:32755',
    layers: 'act:easements',
    format: 'image/gif',
    tiled: true,
    opacity: 0.6
  },
  UNIMPROVED_LAND_VALUES: {
    id: 'UNIMPROVED_LAND_VALUES',
    label: 'Unimproved land values',
    srs: 'EPSG:32755',
    layers: 'act:trends',
    format: 'image/gif',
    tiled: true,
    opacity: 0.7
  },
  CONTOURS: {
    id: 'CONTOURS',
    label: 'Land contours',
    srs: 'EPSG:32755',
    layers: 'act:contours',
    format: 'image/gif',
    tiled: true,
    opacity: 0.7
  },
  PRIMARY_SCHOOL: {
    id: 'PRIMARY_SCHOOL',
    label: "Primary Schools - ".concat(currentSchoolYear),
    srs: 'EPSG:32755',
    layers: 'act_primary_school',
    format: 'image/gif',
    tiled: true,
    opacity: 0.7
  },
  HIGH_SCHOOL: {
    id: 'HIGH_SCHOOL',
    label: "High Schools - ".concat(currentSchoolYear),
    srs: 'EPSG:32755',
    layers: 'act_high_school',
    format: 'image/gif',
    tiled: true,
    opacity: 0.7
  },
  COLLEGE: {
    id: 'COLLEGE',
    label: "Colleges - ".concat(currentSchoolYear),
    srs: 'EPSG:32755',
    layers: 'act_college',
    format: 'image/gif',
    tiled: true,
    opacity: 0.7
  },
  FUTURE_PRIMARY_SCHOOL: {
    id: 'FUTURE_PRIMARY_SCHOOL',
    label: "Primary Schools - ".concat(nextSchoolYear),
    srs: 'EPSG:32755',
    layers: 'future_act_primary_school',
    format: 'image/gif',
    tiled: true,
    opacity: 0.7
  },
  FUTURE_HIGH_SCHOOL: {
    id: 'FUTURE_HIGH_SCHOOL',
    label: "High Schools - ".concat(nextSchoolYear),
    srs: 'EPSG:32755',
    layers: 'future_act_high_school',
    format: 'image/gif',
    tiled: true,
    opacity: 0.7
  },
  FUTURE_COLLEGE: {
    id: 'FUTURE_COLLEGE',
    label: "Colleges - ".concat(nextSchoolYear),
    srs: 'EPSG:32755',
    layers: 'future_act_college',
    format: 'image/gif',
    tiled: true,
    opacity: 0.7
  }
};
export default WMSMapLayer;